<template>
    <div>
        <h1>Unmapped AP</h1>
        <VendorForm
            :vendorName="vendorName"
            :clientName="clientName"
            :clientId="clientId"
            :vendorTotalSpend="vendorTotalSpend"
            :vendorId="vendorId"
            type="unmappedAP"
            ref="vendorForm"
        />
        <div class="mt-5">
            <VendorAllocation
                :vendorAllocation="vendorAllocation"
                :vendorTotalSpend="vendorTotalSpend"
                ref="vendorAllocation"
            />
        </div>
    </div>
</template>

<script>
import { storeData } from "../../../store";
import VendorForm from "./VendorForm";
import VendorAllocation from "./VendorAllocation";
import { UpmappedAP } from "../vendorQueries";
export default {
    name: "unmappedAP",
    components: {
        VendorAllocation,
        VendorForm,
    },
    data() {
        return {
            vendorId: storeData.vendorData.id,
            vendorName: "",
            clientName: "",
            clientId: "",
            vendorAllocation: [],
            vendorTotalSpend: "",
        };
    },
    mounted() {
        this.fetchUnmappedAP();
    },
    methods: {
        async fetchUnmappedAP() {
            try {
                const { data } = await this.$apollo.query({
                    query: UpmappedAP,
                    variables: {
                        vendor_identifier: this.vendorId,
                    },
                });
                console.log("data", data);
                this.vendorName =
                    data.spendmd_db_get_vendor_name[0].vendor_name;
                this.clientName =
                    data.spendmd_db_get_vendor_name[0].client_name;
                this.clientId = data.spendmd_db_get_vendor_name[0].client_id;
                this.vendorAllocation =
                    data.spendmd_db_ap_unmapped_aggregate.nodes;
                this.vendorTotalSpend =
                    data.spendmd_db_ap_unmapped_aggregate.aggregate.sum.total_spend;
                console.log("vendorAllocation", this.vendorTotalSpend);
            } catch (err) {
                console.error("Error fetching unmapped AP data:", err);
            }
        },
        getVendorAllocation() {
            const vendorAllocation =
                this.$refs.vendorAllocation.getVendorAllocations();
            return vendorAllocation;
        },
        getVendorForm() {
            const vendorForm = this.$refs.vendorForm.getVendorData();
            return vendorForm;
        },
    },
};
</script>
